module.exports = {"id":"195834","name":"Aymen Mathlouthi","rating":"73","photo":"./data/images/photos/1/195834.png","club":{"name":"Al Batin","logo":"./data/images/clubs/AlBatin.png"},"positions":["G"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AymenMathlouthi0.json
// module id = 506
// module chunks = 0